module.exports = __WEBPACK_EXTERNAL_MODULE_lRwf__;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = lRwf
// module chunks = 71